export default __webpack_public_path__ + "static/media/individualServo.1720bd39.svg";